import React from 'react'
import SupportPrivacyPolicy from '../support-privacy-policy'

const SupportPrivacyPolicyFr = () => {
    return <SupportPrivacyPolicy languageCode="fr" />
}

export default SupportPrivacyPolicyFr
